import type { Session } from '@ms-cloudpack/common-types';
import { getActiveSessionsPath } from '@ms-cloudpack/api-server';
import { writeJson } from '@ms-cloudpack/json-utilities';
import { rm } from 'fs/promises';
import path from 'path';

/**
 * Tracks active sessions to disk as they are started. This gives us a way to enumerate
 * all active sessions for scenarios like better error messages when sessions are already
 * running for a given path, or for the link verb where we want to manipulate an active
 * running session.
 */
export async function trackSession(session: Session): Promise<{ close: () => Promise<void> }> {
  const activeSessionPath = path.join(getActiveSessionsPath(session.cachePath), `${session.id}.json`);

  await writeJson(activeSessionPath, session);

  return {
    async close() {
      // Don't error if something has already deleted the file (most likely in tests)
      await rm(activeSessionPath, { force: true });
    },
  };
}
